import {createContext} from 'react';

export type SidebarMenuButtonContextProps = {
  isActive: boolean;
  highlighted: boolean;
};

export const SidebarMenuButtonContext =
  createContext<SidebarMenuButtonContextProps | null>(null);
